export enum ELevelKey {
  CHARM = 'charm',
  MOON_GEM = 'moon_gem',
  GOLD_ACORN = 'gold_acorn',
  MAGIC_GATE = 'magic_gate',
  EMERALD = 'emerald',
  RAINBOW_VAULT = 'rainbow_vault',
  ELF_TREASURE = 'elf_treasure',
}

export enum EProgressStep {
  START = 0,
  QUARTER = 25,
  HALF = 50,
  THREE_QUARTERS = 75,
  COMPLETE = 100,
}

export enum ERewardMode {
  /** the bonus is credited on its own, the player only activates it */
  AUTO = 'auto',
  /** L6-L7: a lootbox arrives and the player picks a prize inside it */
  LOOTBOX = 'lootbox',
}

export enum ELevelState {
  LOCKED = 'locked',
  IN_PROGRESS = 'inProgress',
  /** target reached, the reward is issued and waits to be activated */
  ISSUED = 'issued',
  CLAIMED = 'claimed',
}

export interface ILevelConfig {
  key: ELevelKey;
  order: number;
  startAmount: number;
  targetAmount: number;
  rewardMode: ERewardMode;
  artifact: string;
  // hero scene, changes with the level: backdrop and the characters over it
  heroBg: string;
  heroCharsDesk: string;
  heroCharsMob: string;
}

export interface IStatusGroup {
  levelKey: ELevelKey;
  step: EProgressStep;
}

export interface ILevel extends ILevelConfig {
  state: ELevelState;
  progress: number;
}
